var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIphone = function SvgIphone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.139,
    height: 16,
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.162 0H1.977A1.857 1.857 0 0 0 0 1.7v12.6A1.857 1.857 0 0 0 1.977 16h6.185a1.857 1.857 0 0 0 1.977-1.7V1.7A1.857 1.857 0 0 0 8.162 0M5.069 14.546a.735.735 0 1 1 0-1.455.735.735 0 1 1 0 1.455M6.332 2.182h-2.53a.4.4 0 0 1-.423-.364.4.4 0 0 1 .423-.364h2.53a.4.4 0 0 1 .422.364.4.4 0 0 1-.422.364m0 0"
  })));
};
export default SvgIphone;